import React, { useCallback } from "react"
import { WithContext as ReactTags } from "react-tag-input"
import styled from "styled-components"
import { KeyCode } from "../../../../enum/keycode"
import Color from "../../../../style/enum/color"
import { Container, IContainerProps } from "./container"

const delimiters: KeyCode[] = [
  KeyCode.Comma,
  KeyCode.Space,
  KeyCode.Enter,
  KeyCode.Tab,
]

const Component = (props: IContainerProps) => {
  const remove = useCallback(
    (i: number) => {
      if (props.tags && props.tags[i]) {
        props.actions.removeTag(props.tags[i])
      }
    },
    // eslint-disable-next-line
    [props.tags],
  )

  const add = useCallback(
    (tag: { id: string; text: string }) => {
      props.actions.addTag(tag.text)
      // eslint-disable-next-line
    }, [])

  return (
    <StyledWrapper>
      <ReactTags
        tags={(props.tags || []).map(tag => ({
          id: tag,
          text: tag,
        }))}
        handleDelete={remove}
        handleAddition={add}
        delimiters={delimiters}
        placeholder={"タグを追加"}
        allowDragDrop={false}
        maxLength={32}
        autofocus={false}
      />
    </StyledWrapper>
  )
}

export const Tags = Container(Component)

const StyledWrapper = styled.div`
  margin: 20px 0;
  font-size: 1rem;
  color: ${Color.DIMGRAY};
  .ReactTags__tag {
    padding: 5px 10px 5px 0;
    display: inline-block;
  }
  .ReactTags__tagInput {
    padding: 5px 10px 5px 0;
    display: inline-block;
    ::placeholder {
      color: ${Color.DIMGRAY};
    }
  }
  .ReactTags__remove {
    margin-left: 2px;
  }
`
